module.exports = __webpack_public_path__ + "static/commision-img1-9c52f643bf1fa32df0244bd8a3fe415d.jpg";